<template>
  <div class="left-box2" style="position: relative">
    <!-- <div class="left-title d-aligncnter">
      <img class="img-24" src="@/assets/img/academic/alarm.svg" />
      <div class="ml-4">各年级学业预警分布</div>
    </div> -->
    <div class="" style="margin-top: 0px">
      <div class="echarts d-allcenter" style="position: absolute">
        <div
          id="grade122"
          :style="{
            width: '388px',
            height: '388px',
            margin: '0 auto',
          }"
        ></div>
      </div>
      <div class="d-allcenter" style="position: absolute; bottom: 62px; width: 100%">体质测试合格率(已测)</div>
      <div style="position: absolute; bottom: 32px; width: 100%" class="d-aligncnter d-allcenter">
        <div v-for="(item, index) in data" :key="'data_' + index" class="d-aligncnter myfont">
          <div :style="{ background: myColor[index] }" class="small-box"></div>
          <div style="font-size: 0.2rem; white-space: nowrap">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['passRate'],
  data() {
    return {
      option: {},
      myColor: ['#9419F8', '#F97423', '#3F8159', '#DE3831', '#9419F8', '#4937B9'],
      data: [
        { name: '男生', value: 12, percent: '60%' },
        { name: '女生', value: 12, percent: '5%' },
        { name: '合格率', value: 12, percent: '35%' },
      ],
      data2: [
        { name: '男生', value: 12, percent: '60%' },
        { name: '女生', value: 12, percent: '5%' },
        { name: '合格率', value: 12, percent: '35%' },
      ],
      genderData: [
        { value: 1548, name: '男合格数' },
        { value: 775, name: '女合格数' },
      ],
      allData: [
        { value: 1048, name: '合格率' },
        { value: 335, name: '不合格' },
      ],
    }
  },
  watch: {
    passRate: {
      handler: function (newVal) {
        this.genderData[0].value = newVal.boyPassNum
        this.genderData[1].value = newVal.girlPassNum
        this.allData[0].value = newVal.passNum
        this.allData[1].value = newVal.noPassNum
        var myChart1 = this.$echarts.init(document.getElementById('grade122'))
        myChart1.setOption(this.option)
      },
      deep: true,
    },
  },
  created() {
    // var myChart1 = this.$echarts.init(document.getElementById('grade'))
    // myChart1.setOption(this.option)
  },
  mounted() {
    const that = this
    new Promise(function (resolve, reject) {
      for (let i = 0; i < that.data2.length; i++) {
        that.data[i].name = that.data2[i].name
        that.data[i].value = that.data2[i].value
      }
      resolve('成功') // 数据处理完成
      reject('成功') // 数据处理完成
    }).then(
      (res) => {
        that.initData()
        console.log(res)
        console.log('data：', this.data)
      }, // 成功
      (err) => {
        console.log(err)
      } // 失败
    )
  },
  filters: {
    failPercent: function (val) {
      return val.toFixed(2)
    },
  },
  computed: {},
  methods: {
    initData() {
      var myChart1 = this.$echarts.init(document.getElementById('grade122'))
      this.option = {
        title: {
          //   text: '本期体测合格率',
          subtext: '',
          left: 'center',
          top: 'bottom',
          textStyle: {
            color: '#fff',
          },
        },
        color: this.myColor,
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        legend: {
          data: [],
        },
        series: [
          {
            name: '男女合格率',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],

            avoidLabelOverlap: false,
            label: {
              position: 'inside',
              fontSize: 14,
              formatter: '{b}{c}',
              color: '#fff',
            },
            labelLine: {
              show: false,
            },
            data: this.genderData,
          },
          {
            name: '体质测试',
            type: 'pie',
            radius: ['40%', '70%'],
            labelLine: {
              length: 30,
            },
            label: {
              formatter: '{d}%',
              position: 'inside',
            },
            // label: {
            //   formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
            //   backgroundColor: '#F6F8FC',
            //   borderColor: '#8C8D8E',
            //   borderWidth: 1,
            //   borderRadius: 4,
            //   rich: {
            //     a: {
            //       color: '#6E7079',
            //       lineHeight: 22,
            //       align: 'center',
            //     },
            //     hr: {
            //       borderColor: '#8C8D8E',
            //       width: '100%',
            //       borderWidth: 1,
            //       height: 0,
            //     },
            //     b: {
            //       color: '#4C5058',
            //       fontSize: 14,
            //       fontWeight: 'bold',
            //       lineHeight: 33,
            //     },
            //     per: {
            //       color: '#fff',
            //       backgroundColor: '#4C5058',
            //       padding: [3, 4],
            //       borderRadius: 4,
            //     },
            //   },
            // },
            data: this.allData,
          },
        ],
      }
      myChart1.setOption(this.option)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.left-box2 {
  width: 388px;
  height: 435px;
  margin-left: 24px;
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 80%, rgba(0, 122, 77, 0.1) 100%);
  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
.left-title {
  font-size: 22px;
  margin-bottom: 8px;
}
.small-box {
  width: 12px;
  height: 12px;
  border-radius: 90px;
  margin: 0 16px;
}
.myfont {
  font-size: 20px;
  justify-content: space-evenly;
  margin-top: 8px;
  div {
    text-align: center;
  }
}
</style>
